module.exports = __webpack_public_path__ + "static/img/14000604.15366fe9.png";